import { VIEWS_TYPE_COLOR } from "../utils";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { UpIcon, DownIcon } from "../assets/icons";
import { CodeIcon } from "../../../assets/icons";
import ViewsTypeBadge from "./ViewsTypeBadge";
import { Button, PopoverTrigger, Popover, PopoverContent } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

const LineageLegend = () => {
  const [showLegend, setShowLegend] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShowLegend(true);
    }, 500);
    const id = setTimeout(() => {
      setShowLegend(false);
    }, 3500);
    return () => clearTimeout(id);
  }, []);

  return (
    <Popover open={showLegend} onOpenChange={setShowLegend}>
      <PopoverTrigger asChild>
        <Button className={styles.lineage_legend} variant="outline">
          Legend
          {showLegend ? <DownIcon /> : <UpIcon />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="al-tw-scope">
        {Object.keys(VIEWS_TYPE_COLOR).map(k => (
          <Stack key={k} direction="row" gap="sm" align="center" className="mb-1">
            <ViewsTypeBadge viewsType={k} />
            <div>{k}</div>
          </Stack>
        ))}
        <Stack direction="row" gap="sm" align="center" className="mb-1">
          <div className={styles.column_code_icon}>
            <CodeIcon />
          </div>
          <div>Code</div>
        </Stack>
        <Stack direction="row" gap="sm" align="center" className="mb-1">
          <div className={styles.edge_select}>
            <div />
          </div>
          <div>Select</div>
        </Stack>
        <Stack direction="row" gap="sm" align="center" className="mb-1">
          <div className={styles.edge_non_select}>
            <div />
          </div>
          <div>Non select</div>
        </Stack>
      </PopoverContent>
    </Popover>
  );
};

export default LineageLegend;
